module.exports = __webpack_public_path__ + "static/media/check.5b0207bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/check.svg
// module id = 673
// module chunks = 21